import { render } from "./RateSpecial.vue?vue&type=template&id=aad9a21c&scoped=true"
import script from "./RateSpecial.vue?vue&type=script&lang=js"
export * from "./RateSpecial.vue?vue&type=script&lang=js"

import "./RateSpecial.vue?vue&type=style&index=0&id=aad9a21c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aad9a21c"

export default script